import {CargoSubtype, ContainerEntity} from "@ots-frontend/ots-data";
import {Group, Text, ThemeIcon} from "@mantine/core";
import {ComponentPropsWithoutRef, forwardRef, useCallback} from "react";
import {BaseEntitySelect, BaseEntitySelectProps} from "../base-entity-select";
import {IconDropletFilled} from "@tabler/icons-react";
import {getCargoSubtypeColorRefByType} from "../../../../util/cargo-subtype-ui-util";

export type BaseContainerSelectProps = Omit<
  BaseEntitySelectProps<ContainerEntity>,
  'nameMapper'
> & {
  useAbbreviation?: boolean;
  showCargoSubtype?: boolean;
};

type ContainerSelectItemProps = ComponentPropsWithoutRef<'div'> & {
  label: string;
  cargoSubtype?: CargoSubtype;
};

const ContainerSelectItem = forwardRef<HTMLDivElement, ContainerSelectItemProps>((props, ref) => {
  const {label, cargoSubtype, ...rest} = props;

  return (
    <div ref={ref} {...rest}>
      <Group noWrap spacing="xs">
        {cargoSubtype && (
          <ThemeIcon c={getCargoSubtypeColorRefByType(cargoSubtype)} variant="transparent" size={16}>
            <IconDropletFilled size={14}/>
          </ThemeIcon>
        )}
        <Text size="sm">{label}</Text>
      </Group>
    </div>
  );
});

export const BaseContainerSelect = (props: BaseContainerSelectProps) => {
  const {useAbbreviation = false, showCargoSubtype = false, ...rest} = props;

  const nameMapper = useCallback((e: ContainerEntity) => {
    return useAbbreviation ? (e.abbr ?? e.name) : e.name;
  }, [useAbbreviation]);

  const itemDataMapper = useCallback((e: ContainerEntity) => ({
    cargoSubtype: e.cargoSubtype,
  }), []);

  return (
    <BaseEntitySelect
      nameMapper={nameMapper}
      itemComponent={showCargoSubtype ? ContainerSelectItem : undefined}
      itemDataMapper={showCargoSubtype ? itemDataMapper : undefined}
      {...rest} />
  );
};
